"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderState = exports.setOrderState = void 0; // tslint:disable-next-line: strict-type-predicates

var isBrowser = !!(typeof window !== 'undefined' && window.sessionStorage);

var setOrderState = function setOrderState(key, state) {
  if (isBrowser) {
    window.sessionStorage.setItem(key, JSON.stringify(state));
  }
};

exports.setOrderState = setOrderState;

var getOrderState = function getOrderState(key) {
  if (!isBrowser) {
    return undefined;
  }

  var orderState = window.sessionStorage.getItem(key);

  try {
    return orderState ? JSON.parse(orderState) : undefined;
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error("Error loading state at " + key);
    return undefined;
  }
};

exports.getOrderState = getOrderState;